<template>
  <div>
    <div v-if="isPolicyHolder">
      <b-row>
        <b-col>
          <h2>
            <span class="ti-home"></span>
            <span class="mx-2">{{ $t('message.addressList.title') }}</span>
            <small class="text-muted">{{ $t('message.addressList.subtitle') }}</small>
          </h2>
        </b-col>
      </b-row>
      <b-row class="mt-3">
        <b-col>
          <b-card class="rounded-0">
            {{ addressInfo }}
          </b-card>
        </b-col>
      </b-row>
      <b-row
        v-for="i in Math.ceil(addresses.length / 3)"
        class="mt-3"
        :key="i">
        <b-col
          v-for="address in addresses.slice((i - 1) * 3, i * 3)"
          class="mt-md-4 mt-lg-0"
          :key="address.id">
          <b-link
            class="address-link"
            :to="'/addresses/' + address.id">
            <Infobox
              :title="getTitle(address)"
              :subtitle="getSubtitle(address)"
              :message="getMessage(address)">
              <span class="infobox-icon ti-home"></span>
            </Infobox>
          </b-link>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <router-view></router-view>
        </b-col>
      </b-row>
    </div>
    <div v-if="!isPolicyHolder">
      <div v-if="!isEditable">
      <b-row>
        <b-col>
          <h2>
            <span class="ti-home"></span>
            <span class="mx-2">{{ $t('message.addressList.title') }}</span>
            <small class="text-muted">{{ $t('message.addressList.subtitleNonPolicyHolder') }}</small>
          </h2>
        </b-col>
        </b-row>
        <b-row class="mt-3">
        <b-col>
          <b-card class="rounded-0">
            {{ addressInfo }}
          </b-card>
        </b-col>
      </b-row>
        <b-row
        v-for="i in Math.ceil(addresses.length / 3)"
        class="mt-3"
        :key="i">
        <b-col
          v-for="address in addresses.slice((i - 1) * 3, i * 3)"
          class="mt-md-4 mt-lg-0"
          :key="address.id">
          <div>
            <infobox
            :message="getMessage(address)"
            :title="getTitle(address)"
            :subtitle="getSubtitle(address)"
            variant="noHover">
            <span class="infobox-icon ti-home"></span>
          </Infobox>
            <b-row class="mt-4">
              <b-col class="text-right">
                <b-btn variant="primary" @click="editAddress(address)">{{ $t('message.addressDetails.btn.edit') }}</b-btn>
                <b-btn variant="danger" @click="setCurrentAddress(address)" v-b-modal.delete-address-model>{{ $t('message.addressDetails.btn.delete') }}</b-btn>
              </b-col>
            </b-row>
          </div>
        </b-col>
      </b-row>
      <b-row class="mt-4">
        <b-col>
          <router-view></router-view>
        </b-col>
      </b-row>
    </div>
    <div v-else>
      <b-row class="mt-4">
        <b-col cols="10">
          <address-form
            ref="addressForm"
            :address="getCurrentAddress()"
            :onSubmitFn="saveAddress">
          </address-form>
        </b-col>
      </b-row>
      <b-row>
        <b-col
          cols="10"
          class="text-right px-4">
          <b-btn
            variant="link"
            @click="cancel">
            {{ $t('message.addressDetails.btn.cancel') }}
          </b-btn>
          <b-btn
            variant="primary"
            @click="saveAddress">
            {{ $t('message.addressDetails.btn.save') }}
          </b-btn>
        </b-col>
      </b-row>
    </div>
    </div>
     <b-modal id="delete-address-model"
             cancel-variant="primary"
             ok-variant="danger"
             :title="$t('message.addressDetails.modal.title')"
             :ok-title="$t('message.addressDetails.modal.btn.ok')"
             :cancel-title="$t('message.addressDetails.modal.btn.cancel')"
             @ok="deleteAddress">
      <p class="mt-4">{{ $t('message.addressDetails.modal.question') }}</p>
    </b-modal>
  </div>
</template>

<script>
  import AddressForm from '@/components/address/AddressForm'
  import Infobox from '@/components/common/Infobox'
  import Icon from 'vue-awesome/components/Icon'
  import 'vue-awesome/icons/home'

  export default {
    components: {
      AddressForm,
      Infobox,
      Icon
    },
    computed: {
      addresses () {
        return this.$store.getters.addresses
      },
      addressInfo () {
        if (this.isPolicyHolder) {
          return this.$t('message.addressList.addressInfo.policyHolder')
        } else if (this.isContactPerson) {
          return this.$t('message.addressList.addressInfo.contactPerson')
        }
      },
      isContactPerson () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesContactPerson = currentUser.roles.filter(role => role.roleOfUser === 'CONTACT_PERSON')
          if (rolesContactPerson.length > 0) {
            return true
          }
        }
        return false
      },
      isPolicyHolder () {
        const currentUser = this.$store.getters.currentUser
        if (Object.keys(currentUser).length > 0) {
          const rolesPolicyHolder = currentUser.roles.filter(role => role.roleOfUser === 'POLICY_HOLDER')
          if (rolesPolicyHolder.length > 0) {
            return true
          }
        }
        return false
      }
    },
    data () {
      return {
        isEditable: false,
        newAddress: null,
        selectedAddress: null
      }
    },
    created () {
      this.$store.dispatch('fetchAddresses')
    },
    methods: {
      getTitle (_address) {
        return `${_address.street} ${_address.streetNumber}`
      },
      cancel () {
        this.isEditable = false
      },
      deleteAddress () {
        let deletionId = this.selectedAddress.id
        if (deletionId !== null && deletionId !== undefined) {
          this.$store.dispatch('deleteAddressById', deletionId)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.addressDetails.deleteAddress')
            })
            this.$store.dispatch('fetchAddresses')
            this.selectedAddress = null
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.addressDetails.deleteAddress')
            })
            this.selectedAddress = null
          })
        }
      },
      editAddress (_address) {
        this.setCurrentAddress(_address)
        this.isEditable = true
      },
      setCurrentAddress (_address) {
        this.selectedAddress = _address
      },
      getCurrentAddress () {
        return this.selectedAddress
      },
      getMessage (address) {
        if (!this.isPolicyHolder) {
          return ''
        }
        return (address.numberOfContracts === 1) ? this.$t('message.addressList.infobox.messageSingle')
          : this.$t('message.addressList.infobox.message', {numberOfContracts: address.numberOfContracts})
      },
      getSubtitle (address) {
        return `${address.postalCode} ${address.city}`
      },
      saveAddress () {
        this.$store.dispatch('updateAddress', this.selectedAddress)
          .then(() => {
            this.showSuccessMsg({
              message: this.$t('message.addressDetails.saveAddress')
            })
            this.isEditable = false
            this.selectedAddress = null
          })
          .catch(() => {
            this.showErrorMsg({
              message: this.$t('error.addressDetails.saveAddress')
            })
            this.selectedAddress = null
          })
      }
    },

    notifications: {
      showSuccessMsg: {
        type: 'success'
      },
      showErrorMsg: {
        type: 'error'
      }
    }
  }
</script>

<style scoped>
  .btn-purple {
    color: #fff;
    background: #5c4ac7;
    border: 1px solid #5c4ac7;
  }

  .btn-purple:active {
    background-color: #5c4ac7;
    border: 1px solid #5c4ac7;
  }

  .address-link, address-link:hover {
    color: #455a64;
    text-decoration: none;
  }
</style>



// WEBPACK FOOTER //
// src/components/address/AddressList.vue